import type { FieldState } from 'final-form';

import {
  validateBlacklistedSingleValue,
  validateNotEmpty,
  validatePartialOwnershipByApplicantType,
} from './validators';

// ownershipDropdownValidatorWithBlacklist will be widely used, thus encapsulate it here as a pipe pattern
export function ownershipDropdownValidatorWithBlacklist(
  isOptional?: boolean,
  validationFailMessage?: string,
  targetApplicantType?: string
) {
  return (values: any, allValues?: Object, fieldMeta?: FieldState<any>) =>
    validateNotEmpty(validationFailMessage || 'Please add an applicant.', isOptional)(values, allValues, fieldMeta) ||
    // applicantClientId is the only attribute to tell the difference between applicant and non-applicant
    // applicantId is both '' for applicant and non-applicant on BP pages
    validateBlacklistedSingleValue(
      '',
      'Select at least one applicant.',
      'applicantClientId',
      isOptional
    )(values, allValues, fieldMeta) ||
    (targetApplicantType
      ? validatePartialOwnershipByApplicantType(validationFailMessage!, undefined, targetApplicantType)(
          values,
          allValues,
          fieldMeta
        )
      : undefined);
}
